import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { CaredocsThemeName } from './caredocsTheme';

interface ThemeState {
  themeName: CaredocsThemeName;
  toggle: () => void;
  set: (name: CaredocsThemeName) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      themeName: 'dark',
      toggle: () =>
        set((s) => ({ themeName: s.themeName === 'dark' ? 'light' : 'dark' })),
      set: (themeName) => set({ themeName }),
    }),
    { name: 'hub.theme', version: 1 },
  ),
);
